import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import s from './BooleanDropDownField.module.scss';
import { Select } from 'src/shared/ui/_inputs/Select';

interface Props extends GeneratedField {
	options?: string[];
}

export const BooleanDropDownField: React.FC<Props> = (props) => {
	const {
		namePrefix, //
		propertyName,
		internalName,
		validate,
		options,
	} = props;

	// * Form
	const { control } = useFormContext();

	const name = `${namePrefix}${propertyName}.${internalName}`;

	const onValueChange = (fieldName: string, value: unknown, onChange: (...event: any[]) => void) => {
		onChange(fieldName, value, { shouldValidate: true });
	};

	// * Render
	return (
		<Controller
			name={`${name}.value`}
			control={control}
			rules={{ validate: validate }}
			render={({ field, fieldState }) => (
				<Select
					{...field}
					className={s.select}
					onChange={(value) => onValueChange(field.name, value, field.onChange)}
					options={[
						{
							value: 'true',
							label: options ? options[1] : 'Yes',
						},
						{
							value: 'false',
							label: options ? options[0] : 'No',
						},
					]}
					error={fieldState.error?.message}
				/>
			)}
		/>
	);
};
